import { ExpiryMethodApi } from '@voladeum/client';
import { v4 as uuidv4 } from 'uuid';

import { ExpiryMethod } from './types';

export const normalizeExpiryMethods = (data: ExpiryMethodApi[]): ExpiryMethod[] =>
  data.map((d) => normalizeExpiryMethod(d));

export const normalizeExpiryMethod = (row: ExpiryMethodApi): ExpiryMethod => {
  return { ...row, uuid: uuidv4() };
};
